import styles from "./AccountUpgrade.module.css";
import upgrade from "../../../../img/accountUpgrade.png";
import { ContentList } from "../../../../screens/MapScreen";
import ContentTitle from "../ContentTitle";
import { ButtonProps } from "../../MiniButton";
import BottomButtonBox from "../../BottomButtonBox";

interface AccountUpgradeProp {
    changeContent: (type: ContentList) => void;
}

/**
 * @author cwlee
 * @date 2024-09-23 16:15:16
 * @remark 신규 장소 등록 화면
 * @param props AddPlaceProps
 * @props changeContent: 사이드 시트 콘텐츠를 변경하는 함수
 */
const AccountUpgrade = (props: AccountUpgradeProp) => {
    const cancel = () => {
        props.changeContent(ContentList.Back);
    };
    const upgradePage = () => {
        props.changeContent(ContentList.List);
    };

    const rightButton: ButtonProps = {
        label: "계정 업그레이드",
        onClick: upgradePage,
    };
    const leftButton: ButtonProps = {
        label: "이전",
        type: "gray",
        onClick: cancel,
    };

    return (
      <div className={styles.wrapper}>
          <ContentTitle title={"계정 업그레이드"} />
            <div className={styles.top}>
                <div className={styles.summary}>
                    프리미엄 계정으로 업그레이드
                </div>
                <div>
                    <img
                        className={styles.upgradeImg}
                        src={upgrade}
                        alt="계정업그레이드사진"
                    ></img>
                </div>
                <div className={styles.desc}>
                    <div>
                        일반 회원의 지도는 최대 500개까지만 장소를 등록할 수
                        있어요
                    </div>
                    <div>
                        계정 등급을 업그레이드 하여, 최대 20000개까지의 장소를
                        등록가능한 나만의 개인지도를 만들어보세요
                    </div>
                </div>
            </div>
            <div className={styles.bottom}>
                <BottomButtonBox right={rightButton} left={leftButton}/>
            </div>
        </div>
    );
};

export default AccountUpgrade;
